<template>
  
</template>
<script>
import { chayuangong,GenToken } from "../api/api";
export default {
    name:"deslogin",
    data(){
        return{

        }
    },
    methods:{
     gettoken(){
        var obj = {

        }
        GenToken(obj).then(data=>{
        if(data.ResultCode == 1){
            console.log(data,"datatoken")
            localStorage.token = data.Token
            this.getinfoById()
        }
       })
     },
     getinfoById(){
        var obj = {
            userId:this.$route.query.Id
        }
        chayuangong(obj).then(data=>{
            if(data.ResultCode == 1){
              var _this = this
              data = data.ResultObj;
              console.log(data)
              _this.$cookie.set("OperatorId", data.Id);
              // if(data.LastLoginTime == null){
              // this.force = true
              // }else{
              localStorage.Id = data.Id;
              localStorage.Name = data.Name;
              localStorage.BbId = data.BbId;
              localStorage.UserType = data.UserType;
              // localStorage.setItem("token", data.token);
              localStorage.setItem("currentPath", "/banner");
              _this.$cookie.set("BrandId", data.BbId);
              _this.$cookie.set("Name", data.Name);
              
              
           
              _this.$cookie.set("UserType", data.UserTypeId);
              _this.$cookie.set("ZoneId", data.ZoneId);
              _this.$cookie.set("Phone", data.Phone);
              _this.$cookie.set("OpenId", data.OpenId);
              _this.$cookie.set("OperatorId", data.Id);
              _this.logining = false;
              // let { msg, code, user } = data;
              // if (data.LastLoginTime == null) {
              //   this.force = true;
              //   this.ruleForm2.code = "";
              //   this.isdisabled = "";
              // } else {
              //   _this.$router.replace("/banner");
              // }
               _this.$router.replace("/banner");
            //    window.open("https://www.baidu.com",'_self')
            }else{
                window.open("https://www.taozhuanr.com",'_self')
            }
        })
     }
    },
    mounted(){
        this.gettoken()
        //   this.getinfoById()
    }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// deslogin.vue?27d28665